var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSilhouette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 110,
    fill: "#ffffff",
    viewBox: "0 0 24 24",
    width: 110,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93",
    "data-name": "Layer 93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19 5h-1v-2a1 1 0 0 0 -2 0v2h-8v-2a1 1 0 0 0 -2 0v2h-1a3 3 0 0 0 -3 3v1h20v-1a3 3 0 0 0 -3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8h-20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSilhouette);
export default __webpack_public_path__ + "static/media/calendar-silhouette.f8d8e8fc4b4caf7c49152e9f9ea531f4.svg";
export { ForwardRef as ReactComponent };